module.exports = __webpack_public_path__ + "img/rotary-international.4281f073.svg";